import React, { memo, useEffect } from 'react';
import { Flex, IconButton, Text } from 'onefaceui-react-components';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import CloseIcon from 'static/images/chat/close.svg';
import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/alerts';
import { Container } from './CoordinatesAlert.styles';

function CoordinatesAlert({ alertKey }) {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.alerts.getIn([alertKey, 'isOpen']));
  const title = useSelector((state) => state.alerts.getIn([alertKey, 'title']));
  const description = useSelector((state) => state.alerts.getIn([alertKey, 'description']));

  function handleOnClose() {
    dispatch(actionCreators.closeAlert({ key: alertKey }));
  }

  useEffect(() => {
    const onClick = (e) => {
      if (e.key === 'Escape') {
        handleOnClose();
      }
    };

    window.addEventListener('keyup', onClick);

    return () => {
      dispatch(actionCreators.closeAlert({ key: alertKey }));

      window.removeEventListener('keyup', onClick);
    };
  }, []);

  if (!isOpen) return null;

  return (
    <Container data-testid={`alert-${alertKey}`} className="coordinates-alert" flexDirection="column">
      <Flex alignItems="center" justifyContent="space-between">
        <Text type="light" weight="bold">{title}</Text>
        <IconButton
          data-testid={`close-${alertKey}`}
          variant="neutral"
          onClick={() => handleOnClose()}
          title={getResourceTo('coordinatesAlert.closeButton.title')}
        >
          <img src={CloseIcon} alt="Close" />
        </IconButton>
      </Flex>
      <Text size="sm" type="light">{description}</Text>
    </Container>
  );
}

CoordinatesAlert.propTypes = {
  alertKey: PropTypes.string.isRequired
};

export default memo(CoordinatesAlert);
